<template>
  <div>
    <!--    기본정보-->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 기본정보
        </h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">현장명</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
        <company-selector
          v-else
          v-model="form.inputA_1"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">소속명</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_2 }}</p>
        <ml-input
          v-else
          v-model="form.inputA_2"
          class="w-full flex-1"
          :readonly="true"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">부서명</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>
        <ml-input
          v-else
          v-model="form.inputA_3"
          class="w-full flex-1"
          :readonly="true"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">직책</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_4 }}</p>
        <ml-input
          v-else
          v-model="form.inputA_4"
          class="w-full flex-1"
          :readonly="true"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성자</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_5 }}</p>
        <ml-input
          v-else
          v-model="form.inputA_5"
          class="w-full flex-1"
          :readonly="true"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성일</div>
        <span v-if="isPrint"> {{form.inputA_6}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputA_6" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검일</div>
        <span v-if="isPrint"> {{form.inputA_7}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputA_7" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검장소</div>
        <span v-if="isPrint"> {{form.inputA_8}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_8" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">재해형태</div>
        <span v-if="isPrint"> {{form.inputA_9}} </span>
        <disaster-class-selector
          v-else
          class="w-full flex-1"
          v-model="form.inputA_9"
          :readonly="board.readonly"
        />
      </div>
    </div>


    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
        ><h5><i class="dot"></i>사진대지</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 h-upload">
        <div class="col-span-6 upload-content">
          <div class="upload-content__file">
            <FileUploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputD_1"
            />
            <img class="w-full h-full" v-else :src="form.inputD_1.thumb" />
          </div>
          <div class="upload-content__input">
            <p v-if="isPrint" class="w-full">{{ form.inputD_2 }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="form.inputD_2"
              class="w-full h-full"
            />
          </div>
        </div>

        <div class="col-span-6 upload-content">
          <div class="upload-content__file">
            <FileUploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputD_3"
            />
            <img class="w-full h-full" v-else :src="form.inputD_3.thumb" />
          </div>
          <div class="upload-content__input">
            <p v-if="isPrint" class="w-full">{{ form.inputD_4 }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="form.inputD_4"
              class="w-full h-full"
            />
          </div>
        </div>

        <div class="col-span-6 upload-content">
          <div class="upload-content__file">
            <FileUploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputD_5"
            />
            <img class="w-full h-full" v-else :src="form.inputD_5.thumb" />
          </div>
          <div class="upload-content__input">
            <p v-if="isPrint" class="w-full">{{ form.inputD_6 }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="form.inputD_6"
              class="w-full h-full"
            />
          </div>
        </div>

        <div class="col-span-6 upload-content">
          <div class="upload-content__file">
            <FileUploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputD_7"
            />
            <img class="w-full h-full" v-else :src="form.inputD_7.thumb" />
          </div>
          <div class="upload-content__input">
            <p v-if="isPrint" class="w-full">{{ form.inputD_8 }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="form.inputD_8"
              class="w-full h-full"
            />
          </div>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import config from '/public/config'
import VueCookie from 'vue-cookie'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (value) {
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.projectTitle
      }
    },
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_2
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle:'작업발판·비계 및 개구부',

      form: {
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputA_7: '',
        inputA_8: '',
        inputA_9: '',

        inputD_1: {},
        inputD_2: '',
        inputD_3: {},
        inputD_4: '',
        inputD_5: {},
        inputD_6: '',
        inputD_7: {},
        inputD_8: '',

        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '',
          is_checked: ''
        },
        {
          id: 2,
          label: '',
          is_checked: ''
        },
        {
          id: 3,
          label: '',
          is_checked: ''
        },
        {
          id: 4,
          label: '',
          is_checked: ''
        },
        {
          id: 5,
          label: '',
          is_checked: ''
        },
        {
          id: 6,
          label: '',
          is_checked: ''
        },
        {
          id: 7,
          label: '',
          is_checked: ''
        },
        {
          id: 8,
          label: '',
          is_checked: ''
        },
        {
          id: 9,
          label: '',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
